import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { DocumentsDetailContent } from './components/DocumentsDetailContent';

export default function DocumentsDetail() {
    return (
        <MainContent
            component={<DocumentsDetailContent />}
            titulo='Detalle de Documento'
            noBackground
            tableMaxWidth
        />
    );

};
